import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
      ]
    },
    Theme: {
      validations: []
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'},
      ]
    },   
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'FirstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:',
            mapping: 'TelNumber'
          }
        ]
      },
          {
            fields: [
              {
                type: 'date-picker',
                size: 'Medium',
                label: 'Event Date:',
                mapping: 'EventDate'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Event Type:',
                mapping: 'Theme'
              }
            ]
          },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Dundee Resort & Golf Club Contact Form',
    formId: '1879',
    clientKey: 'BDD9CD1C-5B67-4A20-9FE1-1759800ED9C6',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
